import './AttachFilesBlockSkeleton.scss';
import React from 'react';
import Skeleton from '@srm/ui/skeleton';

export interface IAttachFilesBlockSkeletonProps {
    id?: string;
}

// Пустой блок после загрузки модели содержит только компактную дропзону.
const AttachFilesBlockSkeleton: React.FC<IAttachFilesBlockSkeletonProps> = ({ id }) => (
    <div
        className="attach-files-block-skeleton"
        aria-busy="true"
        aria-label="Загрузка блока вложений"
        data-testid={id ? `attach-files-block-loading-${id}` : undefined}
    >
        <div className="attach-files-block-skeleton__dropzone">
            <Skeleton height={40} width={40} radius={9} />
            <div className="attach-files-block-skeleton__body">
                <Skeleton height={16} width="min(240px, 70%)" radius={6} />
                <Skeleton height={12} width="min(300px, 85%)" radius={6} />
            </div>
        </div>
    </div>
);

export default AttachFilesBlockSkeleton;
